@import '~style-sheet-helpers/core.less';

@import '../../../../../constants/spacing.module.less';

.modal-content-title {
  margin-bottom: @space-8;
}
